import React, {Component} from "react";
import Subscribe from "../components/Subscribe";
import {getOffers} from "../store/actions/offerActions";
import {getSpecialtiesList} from "../store/actions/specialtyActions";
import {clearBlogData, getPostsListsPage} from "../store/actions/blogActions";
import {connect} from "react-redux";
import Intro from "../components/home/Intro";
import {withTranslate} from "react-redux-multilingual"
import globalMiddleware from "../hocs/globalMiddleware";
import Blog from "../components/blog/BlogHome";
import Offers from "../components/offers/Offers";
import WorkProcess from "../components/home/WorkProcess";
import ReactGA from 'react-ga';
import Search from "../components/home/Search";
import Maintenance from "../components/Maintenance";
import {setCurrentRoute, clearError500} from "../store/actions/globalActions";
import {getHomeSliders,clearHomeIntro} from "../store/actions/homeSliderActions";


class Home extends Component {


    componentDidMount() {
        this.props.clearError500();
        this.props.getFeaturedOffers();
        //this.props.getDoctorsList();
        this.props.getSpecialtiesList(1);
        this.props.clearBlogData();
        this.props.getPostsListsPage(1, "categories", "", 2);
        this.onGALoad();
        window.scrollTo(0, 0);
        this.props.setCurrentRoute(window.location.href);


        const script = document.createElement("script");
        script.src = "https://grey.paysky.io:9006/invchost/JS/LightBox.js";
        script.async = true;
        document.body.appendChild(script);
    }




    onGALoad = () => {
        ReactGA.initialize('UA-125116959-1', {
            debug: true,
            titleCase: false,
        });
    };




    render() {
        const {posts, error500, postsIsLoading, featuredOffers, featuredOffersListIsLoading} = this.props;

        if (error500) {
            return (
                <Maintenance/>
            )
        }


        return (
            <div className="home">
                {/*<button onClick={() => this.pay()}>Pay</button>*/}

                <Intro sliders={this.props.sliders}
                       sliderIsLoading={this.props.sliderIsLoading}
                       clearHomeIntro={this.props.clearHomeIntro}
                       getHomeSliders={this.props.getHomeSliders}/>
                {/*     <Search  />*/}
                <Search sliders={this.props.sliders} mobileMenuIsShown={this.props.mobileMenuIsShown}/>

                <WorkProcess/>

                <Offers language={this.props.language} offers={featuredOffers}
                        offersListIsLoading={featuredOffersListIsLoading}
                isHome={true}/>

                {/*<Doctors doctors={doctors} doctorsListIsLoading={doctorsListIsLoading}/>*/}

                <Blog posts={posts} loading={postsIsLoading}/>

                <Subscribe/>

            </div>
        )
    }
}


const mapStateToProps = (state) => {
    return {
        doctors: state.doctor.featuredDoctors,
        doctorsListIsLoading: state.doctor.featuredDoctorsListIsLoading,
        featured_specialties: state.specialty.featured_specialties,
        specialtyListIsLoading: state.specialty.specialtyListIsLoading,
        featuredOffers: state.offer.featuredOffers,
        featuredOffersListIsLoading: state.offer.featuredOffersListIsLoading,
        posts: state.blog.posts,
        postsIsLoading: state.blog.postsIsLoading,
        error500: state.global.error500,
        sliders: state.home.sliders,
        sliderIsLoading: state.home.sliderIsLoading,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getFeaturedOffers: () => dispatch(getOffers(1)),
        //getDoctorsList: () => dispatch(getDoctorsList()),
        getSpecialtiesList: (featured) => dispatch(getSpecialtiesList(featured)),
        getPostsListsPage: (page, queryString, keyword, limit) => dispatch(getPostsListsPage(page, queryString, keyword, limit)),
        clearBlogData: () => dispatch(clearBlogData()),
        setCurrentRoute: (route) => dispatch(setCurrentRoute(route)),
        getHomeSliders: () => dispatch(getHomeSliders()),
        clearHomeIntro: () => dispatch(clearHomeIntro()),
        clearError500: () => dispatch(clearError500())
    }
};


export default connect(mapStateToProps, mapDispatchToProps)(globalMiddleware(withTranslate(Home)))
